export type ElComponentShape = 'rectangle' | 'semi-round' | 'round';
